import { Link, List, Text } from "@shopify/polaris"
import { useEffect, useMemo, useRef } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useIntercom } from "react-use-intercom"

import MigrateSetupGuideTabContent from "../components/MigrateSetupGuideTabContent"
import { MigrateSetupGuideTabProps } from "./types"

const GOOD_TO_KNOW_REMINDER_KEYS = [
  "ReviewFinalRemindersItem1",
  "ReviewFinalRemindersItem2",
  "ReviewFinalRemindersItem3",
] as const

const GoodToKnowTab = ({ onCompleteStep, isCompleted }: MigrateSetupGuideTabProps) => {
  const { t } = useTranslation(["dashboard", "common"])
  const { showNewMessage } = useIntercom()
  const hasRequestedCompleteRef = useRef(false)
  const reminderItems = useMemo(
    () => GOOD_TO_KNOW_REMINDER_KEYS.map((key) => t(`dashboard:${key}`)),
    [t],
  )

  useEffect(() => {
    if (isCompleted || !onCompleteStep || hasRequestedCompleteRef.current) {
      return
    }

    hasRequestedCompleteRef.current = true
    void onCompleteStep(3)
  }, [isCompleted, onCompleteStep])

  return (
    <MigrateSetupGuideTabContent
      header={t("dashboard:ReviewFinalReminders")}
      description={
        <div className={"w-[532px] max-w-full"}>
          <List type={"number"}>
            {reminderItems.map((item, index) => (
              <List.Item key={GOOD_TO_KNOW_REMINDER_KEYS[index]}>
                <Text as={"p"} variant={"bodyMd"} tone={"subdued"}>
                  {item}
                </Text>
              </List.Item>
            ))}
          </List>
        </div>
      }
      media={<img src={"https://cdn.parcelpanel.com/front-end/2026/tms-migration/good-to-know.svg"} alt={""} />}
      footer={
        <Trans ns={"dashboard"} i18nKey={"NeedHelp"}>
          <Link onClick={() => showNewMessage("")} removeUnderline />
        </Trans>
      }
    />
  )
}

export default GoodToKnowTab
